// extracted by mini-css-extract-plugin
module.exports = {"content":"TextareaCounted_content__28Slj","textarea":"TextareaCounted_textarea__WgOJ-","control":"TextareaCounted_control__2IOR1","count":"TextareaCounted_count__2VEOd"};